const AUDIENCES = [
  "Service businesses",
  "Consultants & advisors",
  "Project-based businesses",
  "Trade & site-based teams",
  "Growing small businesses",
  "Founder-led operators",
  "Professional services",
  "Practical business owners",
];

export default function WhoFor() {
  const loop = [...AUDIENCES, ...AUDIENCES];
  return (
    <section
      data-testid="who-for-section"
      className="py-10 md:py-14 bg-white border-t border-ink/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-6">
        <div className="overline">Built for</div>
      </div>
      <div className="relative no-scrollbar overflow-hidden">
        <div className="marquee-track flex gap-8 md:gap-14 whitespace-nowrap w-max">
          {loop.map((a, i) => (
            <div
              key={`${a}-${i}`}
              className="flex items-center gap-8 md:gap-14"
            >
              <span className="font-serif-display text-xl md:text-3xl tracking-tight text-ink">
                {a}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-brand-red shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
